






























































































import Vue from "vue";
import { Auth, Storage, API } from "aws-amplify";
//import Axios, { AxiosInstance } from "@aws-amplify/api-rest/node_modules/axios";
import InputFile from "@/components/util_parts/InputFile.vue";
import OutputFile from "@/components/util_parts/OutputFile.vue";
import OptsParam from "@/components/util_parts/OptsParam.vue";
import ViewConsole from "@/components/end_parts/ViewConsole.vue";
import SelectLang from "@/components/SelectLang.vue";
import { OptsJson, CsvParamJson } from "types/opts-json";
import Proj4Defs from "@/class/Proj4Defs";

// ファイル分割情報の定義
interface FileParamJson {
  prefix: string;
  surfix: string;
  outprefix: string;
  outsurfix: string;
  fileSize: number;
}

// 定数定義
const minSplitByte = 5242880; // 出力ファイルの最低分割サイズ(これよりも小さいとマージできない ※最後のファイルは大丈夫)
const minOutByteLine = {
  // 変換形式に合わせた1行当たりの文字数[水深値なし, 水深値あり]
  XYtoLM: [22, 28],
  LMtoXY: [12, 18],
};
const maxParallelUpload = 10; // 同時にUploadするファイル数(並列に動作する数が増えるとパフォーマンスが下がる傾向があるため)

export default Vue.extend({
  components: {
    InputFile,
    OutputFile,
    OptsParam,
    ViewConsole,
    SelectLang,
  },
  data() {
    return {
      consoleStr: "", // コンソールに表示される文字
      fileStr: "error", // 入力されたファイルの中身(最大で６行)
      paramJson: {} as OptsJson, // payloadを代入する変数
      outputParamJson: {} as CsvParamJson, // opts.jsonのoutput以下を抽出したパラメータ
      inputParamJson: {} as CsvParamJson, // opts.jsonのinput以下を抽出したパラメータ
      langType: "ja", // 言語の表示状態を格納(jaかen)
      resultLink: "", // link先のURL
      isReadyBackend: true, // サーバのエラー状態を示すフラグ
      startByte: 0, // 分割開始位置
      splitFileCount: 0, // 分割ファイル数
      uploadFileCount: 0, // アップロード済ファイル数
      transformCount: 0, // 変換終了分割ファイル数
      uploadId: "", // 分割Upload用のID
      uploadEtags: [] as Array<string>,
      isInputHeader: false, // 入力ヘッダの有無(記憶用)
      isOutputHeader: false, // 出力ヘッダの有無(記憶用)
      startTime: {} as Date, // 開始時間
      inputThirdHeader: 0,
      titleHeight: 0,
      consoleHeight: 0,
      windowHeight: window.innerHeight,
      scroller: {
        height: "710px",
        "overflow-y": "scroll",
      },
      validateError: true,
      disableButtonTransform: false, //投影変換ボタンを非活性化する　true:非活性化、false:活性化
    };
  },
  watch: {
    paramJson: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  created() {
    Proj4Defs.defs();
    this.paramJson = this.$store.state.payload;
    this.reload();
    const language = window.navigator.language.split("-");
    this.$store.state.lang = language[0];
    this.$i18n.set(language[0]);
  },
  mounted: function () {
    this.handleResize(); //ページ表示時に実行させる
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    reload() {
      // パラメータを代入
      this.outputParamJson = this.paramJson.output.parameter as CsvParamJson;
      this.inputParamJson = this.paramJson.input.parameter as CsvParamJson;
      if (this.inputParamJson.columns[2] === undefined) {
        this.inputThirdHeader = -1;
      } else {
        this.inputThirdHeader = this.inputParamJson.columns[2];
      }
    },
    inputFileParameter(changeKey: string, changeBoolean: boolean) {
      // 出力パラメータのheaderまたはrevers_depthを変更
      this.outputParamJson[changeKey] = changeBoolean;
    },
    inputFileSeparator() {
      // 出力パラメータのseparatorを変更
      this.outputParamJson.separator = this.inputParamJson.separator;
    },
    /** サインイン. */
    onClickSignin() {
      this.$store.commit("setPayload", this.paramJson);
      this.$router.push("/auth");
    },
    /** サインアウト. */
    onClickSignout() {
      Auth.signOut()
        .then(() => {
          this.$store.commit("setUser", null);
        })
        .catch((error) => {
          alert(error);
        });
    },
    /** 投影変換実行. */
    onClickTransform() {
      if (!this.validateError) {
        this.consoleStr = String(
          Vue.i18n.translate("opts.control.validation_error")
        );
        return;
      }
      // 変数の初期化
      this.consoleStr = "";

      this.startByte = 0;
      this.splitFileCount = 0;
      this.uploadFileCount = 0;
      this.transformCount = 0;
      this.startTime = new Date();
      this.resultLink = ""; // ダウンロードリンクを消す
      this.isReadyBackend = true;
      this.disableButtonTransform = true;

      this.isInputHeader = this.paramJson.input.parameter.header;
      this.isOutputHeader = this.paramJson.output.parameter.header;

      // ファイル情報の作成
      const fileSize = this.$store.state.inputFile.size;
      this.paramJson.input.s3key_path = this.makeS3Holder();
      this.paramJson.output.s3key_path = this.paramJson.input.s3key_path;

      const fileName = this.$store.state.inputFile.name;
      let splitPos = fileName.lastIndexOf(".");
      if (splitPos < 0) splitPos = fileName.length;
      let outFileName = this.paramJson.output.local_path;
      let outsplitPos = outFileName.lastIndexOf(".");
      if (outsplitPos < 0) outsplitPos = outFileName.length;
      const paramFile: FileParamJson = {
        prefix: fileName.substring(0, splitPos),
        surfix: fileName.substring(splitPos),
        outprefix: outFileName.substring(0, outsplitPos),
        outsurfix: outFileName.substring(outsplitPos),
        fileSize: fileSize,
      };

      // 分割数計算
      if (fileSize <= minSplitByte) {
        // 分割なし
        this.readFilePart(paramFile, minSplitByte, false);
        return;
      }
      if (!this.$store.state.user) {
        // Guestユーザはサイズ制限する
        alert(Vue.i18n.translate("opts.transform.warn_limit_guest"));
        this.disableButtonTransform = false;
        return;
      }
      // 分割サイズは入力の平均行幅から計算する
      // TODO:50GB以上の変換はマージファイルの上限が10000ファイルのため全体サイズと出力サイズから実行するLambda(実行サイズ違いを切り替える)
      const sliceSize = 5000; // 確認用切り出しサイズ ※LMDみたいのもあるから大きめにとる
      const blob = this.$store.state.inputFile.slice(0, sliceSize);
      const fileReader = new FileReader();
      fileReader.readAsBinaryString(blob);
      fileReader.onloadend = (event) => {
        if (event.target) {
          const readTmp = event.target.result;
          if (typeof readTmp === "string") {
            const startPos = readTmp.indexOf("\n") + 1; // 最初の改行を取得する
            if (startPos > 0) {
              let cnt = -1;
              let endPos = startPos;
              let pos = startPos;
              while (pos >= 0 && pos < sliceSize && cnt < 10) {
                // 数行読み込む
                endPos = pos;
                cnt++;
                pos = readTmp.indexOf("\n", endPos) + 1;
              }
              if (cnt > 0) {
                const aveLineSize = Math.ceil((endPos - startPos) / cnt);
                const dir =
                  this.paramJson.transform.convert == "LMtoXY"
                    ? "LMtoXY"
                    : "XYtoLM";
                const withDepth =
                  this.paramJson.output.parameter.columns.length < 3 ? 0 : 1;
                const splitSize =
                  aveLineSize *
                  Math.ceil(minSplitByte / minOutByteLine[dir][withDepth]);
                const isSplit = fileSize > splitSize;
                this.readFilePart(paramFile, splitSize, isSplit);
                if (isSplit) {
                  // マージ用の情報を作成する
                  this.consoleStr += this.getEllpseTime() + "MargeStartS\n";
                  API.post("apiopts", "/margestart", {
                    body: {
                      filePrefix: paramFile.outprefix,
                      fileSurfix: paramFile.outsurfix,
                    },
                  })
                    .then((res) => {
                      if (this.checkResponse(res, "margefile")) {
                        this.uploadId = res.uploadId;
                        this.consoleStr +=
                          this.getEllpseTime() + "MeargeStartE:\n";
                        const splitNum = Math.ceil(fileSize / splitSize) + 5; // 末端の誤差分余分に確保
                        this.uploadEtags = new Array<string>(splitNum);
                      }
                    })
                    .catch((error) => {
                      this.isReadyBackend = false;
                      this.consoleStr +=
                        "margeStartError:" + JSON.stringify(error) + "\n";
                    });
                }
                return;
              }
            }
          }
        }
        // エラー
        this.isReadyBackend = false;
        this.disableButtonTransform = false;
        this.consoleStr = "File read error.";
      };
    },
    /**
     * ファイルを読み込んで分割しアップロードする
     * @param paramFile ファイル情報の固定部分
     * @param splitSize ファイルの分割サイズ
     * @param isSplit 分割の有無
     */
    readFilePart(
      paramFile: FileParamJson,
      splitSize: number,
      isSplit: boolean = true
    ) {
      if (this.startByte >= paramFile.fileSize) return; // 最後まで分割したら実行しない

      // ファイル分割番号の更新
      const fileno = this.splitFileCount;
      this.splitFileCount++;

      // ファイルの切り出し
      const isEnd = paramFile.fileSize <= this.startByte + splitSize;
      const endByte = isEnd ? paramFile.fileSize : this.startByte + splitSize;
      const blob = this.$store.state.inputFile.slice(this.startByte, endByte);
      this.startByte = endByte;
      const fileReader = new FileReader();
      fileReader.readAsBinaryString(blob);
      fileReader.onloadend = (event) => {
        if (event.target) {
          const sendTmp = event.target.result;
          if (typeof sendTmp === "string") {
            let len = sendTmp.length;
            if (!isEnd) {
              len = sendTmp.lastIndexOf("\n") + 1;
            }
            const sendData = sendTmp.substring(0, len);

            this.consoleStr +=
              this.getEllpseTime() + "SendFileS:" + fileno + ":" + len + "\n";

            // アップロード
            const s3Key =
              this.paramJson.input.s3key_path +
              paramFile.prefix +
              this.getFileNumberString(fileno, isSplit) +
              paramFile.surfix;
            Storage.put(s3Key, sendData, {
              level: this.$store.state.user !== null ? "private" : "public",
            })
              .then((res) => {
                // 投影変換実行
                this.consoleStr +=
                  this.getEllpseTime() + "SendFileE:" + fileno + "\n";
                this.uploadFileCount++;
                this.transform(paramFile, fileno, isSplit);
                // 次の分割ファイル
                if (
                  !isEnd &&
                  this.isReadyBackend &&
                  this.splitFileCount < this.uploadFileCount + maxParallelUpload
                ) {
                  this.readFilePart(paramFile, splitSize);
                }
              })
              .catch((error) => {
                this.isReadyBackend = false;
                this.disableButtonTransform = false;
                alert(JSON.stringify(error));
                this.consoleStr +=
                  "readFilePartError:" + fileno + ":" + error + "\n";
                return;
              });

            // 次の分割ファイル
            if (
              !isEnd &&
              this.isReadyBackend &&
              this.splitFileCount < this.uploadFileCount + maxParallelUpload
            ) {
              this.readFilePart(paramFile, splitSize);
            }
          }
        }
      };
    },
    /**
     * 投影変換を実施する.
     * @param paramFile ファイル情報の固定部分
     * @param fileno ファイル分割番号
     * @param isSplit ファイル分割有無
     */
    transform(paramFile: FileParamJson, fileno: number, isSplit: boolean) {
      this.consoleStr += this.getEllpseTime() + "TransformS:" + fileno + "\n";
      // ヘッダ切替え
      if (fileno === 0) {
        this.paramJson.input.parameter.header = this.isInputHeader;
        this.paramJson.output.parameter.header = this.isOutputHeader;
      } else {
        this.paramJson.input.parameter.header = false;
        this.paramJson.output.parameter.header = false;
      }
      const numStr = this.getFileNumberString(fileno, isSplit);
      this.paramJson.input.s3key_file =
        paramFile.prefix + numStr + paramFile.surfix;
      this.paramJson.output.s3key_file =
        paramFile.outprefix + numStr + paramFile.outsurfix;

      // Lambda実行
      API.post("apiopts", "/transform", {
        body: this.paramJson,
      })
        .then((res) => {
          this.consoleStr +=
            this.getEllpseTime() + "TransformE:" + fileno + "\n";
          if (this.checkResponse(res, "transform")) {
            this.transformCount++;
            if (!isSplit) {
              // 分割していない場合は終了
              if (this.isReadyBackend) this.createDownloadUrl(paramFile);
            } else {
              // 分割ファイルの結合
              API.post("apiopts", "/margecopy", {
                body: {
                  filePrefix: paramFile.outprefix,
                  fileSurfix: paramFile.outsurfix,
                  fileNo: fileno,
                  uploadId: this.uploadId,
                },
              })
                .then((res) => {
                  if (this.checkResponse(res, "margecopy")) {
                    const etag = res.etag;
                    this.consoleStr +=
                      this.getEllpseTime() + "MeargeCopyE:" + fileno + "\n";
                    this.uploadEtags[fileno] = etag;

                    if (this.splitFileCount == this.transformCount) {
                      // 全てのファイルを変換したらマージ実施
                      this.paramJson.input.parameter.header = this.isInputHeader;
                      this.paramJson.output.parameter.header = this.isOutputHeader;
                      if (this.isReadyBackend) this.margeS3Files(paramFile);
                    }
                  }
                })
                .catch((error) => {
                  this.isReadyBackend = false;
                  this.consoleStr +=
                    "margeCopyError:" + JSON.stringify(error) + "\n";
                });
            }
          }
        })
        .catch((error) => {
          this.isReadyBackend = false;
          this.disableButtonTransform = false;
          this.consoleStr += "transformError:" + fileno + ":" + error + "\n";
        });
    },
    /**
     * 分割変換したファイルをマージする.
     * @param paramFile ファイル情報の固定部分
     */
    margeS3Files(paramFile: FileParamJson) {
      // 送信情報の作成
      this.consoleStr += this.getEllpseTime() + "MeargeFileS\n";

      // Lambda実行
      API.post("apiopts", "/margefinish", {
        body: {
          filePrefix: paramFile.outprefix,
          fileSurfix: paramFile.outsurfix,
          uploadId: this.uploadId,
          etags: this.uploadEtags,
          splitCount: this.transformCount,
        },
      })
        .then((res) => {
          // ダウンロードリンクを作成する
          this.consoleStr += this.getEllpseTime() + "MeargeFileE\n";
          if (this.checkResponse(res, "margefile")) {
            if (this.isReadyBackend) this.createDownloadUrl(paramFile);
          }
        })
        .catch((error) => {
          this.isReadyBackend = false;
          this.consoleStr += "MargeFileError:" + JSON.stringify(error) + "\n";
        });
    },
    /**
     * ダウンロード用のURLを取得する
     * @param paramFile ファイル情報の固定部分
     */
    createDownloadUrl(paramFile: FileParamJson) {
      this.consoleStr += this.getEllpseTime() + "Transform finished.\n";
      // ダウンロードリンクを作成する
      const timeup = this.$store.state.user == null ? 300 : 3600;
      const level = this.$store.state.user == null ? "public" : "private";
      Storage.get(
        this.paramJson.output.s3key_path +
          paramFile.outprefix +
          paramFile.outsurfix,
        {
          expires: timeup,
          level: level,
        }
      )
        .then((res) => {
          if (typeof res === "string") {
            this.resultLink = res;
            if (this.transformCount > 1) {
              // マージ前のファイルを削除する
              API.post("apiopts", "/deletefile", {
                body: {
                  filePrefix: paramFile.outprefix,
                  fileSurfix: paramFile.outsurfix,
                  splitCount: this.transformCount,
                },
              })
                .then((res) => {
                  if (this.checkResponse(res, "deletefile")) {
                    this.consoleStr +=
                      this.getEllpseTime() + "Delete file finished.\n";
                  }
                })
                .catch((error) => {
                  this.isReadyBackend = false;
                  this.consoleStr +=
                    "deleteFileError:" + JSON.stringify(error) + "\n";
                });
            }
          }
          this.disableButtonTransform = false;
        })
        .catch((error) => {
          this.isReadyBackend = false;
          this.disableButtonTransform = false;
          this.consoleStr += error;
        });
    },
    /**
     * ゲスト用のフォルダーを取得する.
     * @return 年月日時分秒ミリ秒 + ランダム6桁
     */
    makeS3Holder(): string {
      if (this.$store.state.user !== null) return "";
      // ゲストユーザは仮フォルダーを使用する
      const now = new Date();
      return (
        "" +
        now.getFullYear() +
        ("0" + (now.getMonth() + 1)).slice(-2) +
        ("0" + now.getDate()).slice(-2) +
        ("0" + now.getHours()).slice(-2) +
        ("0" + now.getMinutes()).slice(-2) +
        ("0" + now.getSeconds()).slice(-2) +
        ("00" + now.getMilliseconds()).slice(-3) +
        ("00000" + Math.floor(Math.random() * 1000000)).slice(-6) +
        "/"
      );
    },
    /**
     * 分割ファイルに付加するファイル番号文字を作成する.
     * @param num ファイル番号
     * @param isSplit ファイル分割有無
     * @return 整形した文字
     */
    getFileNumberString(num: number, isSplit: boolean): string {
      return isSplit ? (num > 999 ? "" + num : ("000" + num).slice(-4)) : "";
    },
    /**
     * Lambda実行結果を確認する.
     * @param response LambdaからのResponse Body
     * @return エラーがなければtrue
     */
    checkResponse(response: any, method?: string): boolean {
      if (response && response.error) {
        this.isReadyBackend = false;
        this.disableButtonTransform = false;
        this.consoleStr +=
          "\n" +
          (method ? method + " " : "") +
          "error:" +
          JSON.stringify(response.error) +
          "\n";
        this.paramJson.input.parameter.header = this.isInputHeader;
        this.paramJson.output.parameter.header = this.isOutputHeader;
        return false;
      }
      return true;
    },
    /**
     * 開始時間からの経過時間を取得する.
     * @return 経過時間(ms)
     */
    getEllpseTime(): string {
      const nowTime = new Date();
      const ellpseTime = nowTime.getTime() - this.startTime.getTime();
      return ("      " + ellpseTime).slice(-7) + ":";
    },
    handleResize: function () {
      this.windowHeight = window.innerHeight;
      let obj = document.getElementById("titleId");
      if (obj !== null) {
        this.titleHeight = obj.clientHeight;
      }
      let test = document.getElementById("consoleId");
      if (test !== null) {
        this.consoleHeight = test.clientHeight;
      }
      this.scroller.height =
        String(this.windowHeight - this.titleHeight - this.consoleHeight - 30) +
        "px";
    },
    epsgEvent(event: string) {
      this.$emit("epsgConsole", event);
    },
  },
});
